<template>
  <div class="msg-list">
    <ul>
      <li v-for="(item, index) in msgList" :key="item.id || index">
        <Avatar
          v-if="
            characterInfo.avatar &&
            item.msgType !== 'greeting' &&
            item.msgType !== 'ownMsg'
          "
          :url="characterInfo.avatar"
          @goCharacterDetail="goCharacterDetail"
        />
        <div class="content-wrap">
          <Greeting
            v-if="item.msgType === 'greeting'"
            :msgInfo="item"
          />
          <AiMsg
            v-else-if="item.msgType === 'aiMsg'"
            :msgInfo="item"
            @completed="mdRenderCompleted"
          />
          <OwnMsg
            v-else-if="item.msgType === 'ownMsg'"
            :msgInfo="item"
          />
          <Selfie
            v-else-if="item.msgType === 'selfie'"
            :isOwn="item.msgFrom === 'self'"
            :msgInfo="item"
            @unlock="handleUnlock"
          />
          <Videos
            v-else-if="item.msgType === 'video'"
            :isOwn="item.msgFrom === 'self'"
            :msgInfo="item"
            @unlock="handleUnlockVideo"
            @loaded="handleVideoLoaded"
          />
          <LoadingText
            v-else-if="item.msgType === 'loading'"
          />
          <Timeout
            v-else-if="item.msgType === 'timeout'"
          />
        </div>
      </li>
    </ul>
    <!-- <Unlock v-if="showUnlockPromt" :info="selfiesInfo" :characterId="characterInfo.characterId" @close="handleClose" @updateSelfies="handleUpdateSelfies"/> -->
  </div>
</template>

<script>
import BScroll from '@better-scroll/core';
import Pulldown from '@better-scroll/pull-down';
import ObserveDom from '@better-scroll/observe-dom';
import Avatar from './Avatar';
import Greeting from './Greeting';
import AiMsg from './AiMsg';
import OwnMsg from './OwnMsg';
import Selfie from './Selfie';
import Videos from './Videos';
import LoadingText from './LoadingText';
import Timeout from './Timeout';
// import Unlock from './Unlock';

BScroll.use(Pulldown);
BScroll.use(ObserveDom);

export default {
  name: 'MessageList',
  components: {
    Greeting,
    Avatar,
    AiMsg,
    OwnMsg,
    Selfie,
    Videos,
    LoadingText,
    Timeout,
    // Unlock,
  },
  props: {
    characterInfo: {
      type: Object,
      default: () => ({}),
    },
    msgList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    msgList: {
      handler(val, old = []) {
        const last = val[val.length - 1];
        const oldLast = old[old.length - 1];
        if (val.length > old.length && last === oldLast) {
          this.isPullDown = true;
          this.scroll && this.scroll.refresh();
        } else {
          this.isPullDown = false;
          this.scrollToBottom();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initScroll();
  },
  updated() {
    if (!this.isPullDown) {
      this.scrollToBottom();
    }
  },
  beforeDestroy() {
    this.scroll.destroy();
  },
  data() {
    return {
      selfiesInfo: {},
      showUnlockPromt: false,
    };
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        this.scroll.refresh();
        this.scroll.scrollTo(0, this.scroll.maxScrollY);
      });
    },
    initScroll() {
      const el = this.$el;
      if (!el) return;
      this.scroll = new BScroll(el, {
        click: true,
        scrollY: true,
        observeDOM: true,
        pullDownRefresh: true,
        useTransition: false,
        probeType: 3,
      });
      this.scrollToBottom();
      this.scroll.on('pullingDown', () => {
        this.startY = this.scroll.maxScrollY;
        this.scroll.finishPullDown();
        this.scroll.stop();
        this.$emit('getHistory', () => {
          this.$nextTick(() => {
            this.scroll.refresh();
            const end = this.scroll.maxScrollY;
            const diff = end - this.startY;
            this.scroll.scrollTo(0, diff);
          });
        });
      });
    },
    mdRenderCompleted() {
      if (this.isPullDown) {
        this.scroll.stop();
        this.scroll.refresh();
        const end = this.scroll.maxScrollY;
        const diff = end - this.startY;
        this.scroll.scrollTo(0, diff || 0);
      }
    },
    goCharacterDetail() {
      const { characterId = '' } = this.characterInfo;
      if (!characterId) return;
      this.$router.push(`/characterDetail/${characterId}`);
    },
    handleUnlock(item) {
      this.$emit('updateSelfies', item);
    },
    handleUnlockVideo(item) {
      this.$emit('updateVideos', item);
    },
    async handleVideoLoaded() {
      this.scrollToBottom();
    },
    handleClose() {
      this.showUnlockPromt = false;
    },
  },
};
</script>

<style lang="less" scoped>
.msg-list {
  overflow: hidden;
  padding-top: 12px;
  position: relative;
  ul {
    min-height: calc(100% + 1px);
    padding-bottom: 132px;
    li {
      position: relative;
      margin-bottom: 12px;
      padding: 0 12px;
      display: flex;
      align-items: flex-end;
      .content-wrap {
        flex: 1;
      }
    }
  }
}

</style>
